export default "__VITE_ASSET__BB9CISlt__"